import{Slot as o}from"radix-ui";const l=o.Root,e=o.Root,r=o.Slottable;export{l as Root,e as Slot,r as Slottable};
//# sourceMappingURL=slot.js.map
